export const REQUEST_WHATSAPP_QRCODE_REQUEST = 'REQUEST_WHATSAPP_QRCODE_REQUEST';
export const REQUEST_WHATSAPP_QRCODE_SUCCESS = 'REQUEST_WHATSAPP_QRCODE_SUCCESS';
export const REQUEST_WHATSAPP_QRCODE_FAILURE = 'REQUEST_WHATSAPP_QRCODE_FAILURE';

export const RESET_WHATSAPP_QRCODE = 'RESET_WHATSAPP_QRCODE';
export const RESET_WHATSAPP_CHANNEL_ID = 'RESET_WHATSAPP_CHANNEL_ID';

export const CREATE_WHATSAPP_CHANNEL_REQUEST = 'CREATE_WHATSAPP_CHANNEL_REQUEST';
export const CREATE_WHATSAPP_CHANNEL_SUCCESS = 'CREATE_WHATSAPP_CHANNEL_SUCCESS';
export const CREATE_WHATSAPP_CHANNEL_FAILURE = 'CREATE_WHATSAPP_CHANNEL_FAILED';

export const POLL_WHATSAPP_SET_CHANNEL = 'POLL_WHATSAPP_SET_CHANNEL';
export const POLL_WHATSAPP_CHANNEL_START = 'POLL_WHATSAPP_CHANNEL_START';
export const POLL_WHATSAPP_CHANNEL_STOP = 'POLL_WHATSAPP_CHANNEL_STOP';
export const POLL_WHATSAPP_CHANNEL_SUCCESS = 'POLL_WHATSAPP_CHANNEL_SUCCESS';
export const POLL_WHATSAPP_CHANNEL_FAILURE = 'POLL_WHATSAPP_CHANNEL_FAILURE';
export const POLL_WHATSAPP_CHANNEL_RESET = 'POLL_WHATSAPP_CHANNEL_RESET';



// WEBPACK FOOTER //
// ./src/store/modules/whatsapp/mutation-types.js